import BaseSymbol from "./BaseSymbol";
import PixiSymbols from "../../framework/src/engine/pixi/PixiSymbols";

export default class SymbolFactory extends PixiSymbols {


    constructor(config, layers) {
        super(config, layers);
    }

    createByIndex(index, {name = null, blur = false, layer = undefined }) {

        let symbolName = this.getSymbolNameByIndex(index);

        return new BaseSymbol(symbolName, index, blur);
    }
}
